import { plTranslations } from "./pl";

export function trans(
  key: keyof typeof plTranslations,
  substitutions = {},
): string {
  if (!plTranslations[key]) return key;

  const translation = plTranslations[key];
  if (typeof translation === "function") {
    return translation(substitutions);
  }
  return translation;
}
